(() => {
  // El chat web ahora vive en Odoo, no en n8n. `/webchat/message` solo
  // acepta el mensaje y responde de inmediato (202): el bot todavía no
  // contestó. La respuesta llega por sondeo a `/webchat/messages`, igual
  // que la revisa un agente humano desde Odoo. Ver base_localizacion_clientes
  // (controllers/webchat.py) para el contrato completo.
  const ODOO_BASE = 'https://onlyshop.evolucionai.cl';
  const SEND_URL = `${ODOO_BASE}/webchat/message`;
  const POLL_URL = `${ODOO_BASE}/webchat/messages`;
  const POLL_INTERVAL_MS = 2500;

  const launcher = document.getElementById('onlyshop-webchat-launcher');
  const panel = document.getElementById('onlyshop-webchat-panel');
  const closeButton = document.getElementById('onlyshop-webchat-close');
  const messages = document.getElementById('onlyshop-webchat-messages');
  const form = document.getElementById('onlyshop-webchat-form');
  const input = document.getElementById('onlyshop-webchat-input');
  const sendButton = document.getElementById('onlyshop-webchat-send');

  if (!launcher || !panel || !messages || !form || !input || !sendButton) return;

  const STORAGE_KEY = 'onlyshop_webchat_session';

  // El token lo emite Odoo (bearer aleatorio); nunca se genera en el
  // navegador. `lastId` es el cursor de los mensajes salientes ya
  // mostrados, para no repetirlos entre sondeos ni al recargar la página.
  const loadSession = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return { token: '', lastId: 0 };
      const parsed = JSON.parse(raw);
      return {
        token: typeof parsed.token === 'string' ? parsed.token : '',
        lastId: Number.isFinite(parsed.lastId) ? parsed.lastId : 0,
      };
    } catch {
      return { token: '', lastId: 0 };
    }
  };

  const session = loadSession();

  const saveSession = () => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    } catch {
      // Almacenamiento no disponible (modo privado, cuota, etc.): la
      // conversación sigue funcionando, solo no sobrevive a un recargo.
    }
  };

  const clearSession = () => {
    session.token = '';
    session.lastId = 0;
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      // Ídem: sin almacenamiento no hay nada que limpiar.
    }
  };

  const addMessage = (text, type, pending = false) => {
    const message = document.createElement('div');
    message.className = `onlyshop-webchat-message ${type}${pending ? ' pending' : ''}`;
    message.textContent = text;
    messages.appendChild(message);
    messages.scrollTop = messages.scrollHeight;
    return message;
  };

  const setOpen = (open) => {
    panel.hidden = !open;
    launcher.setAttribute('aria-expanded', String(open));
    if (open) {
      setTimeout(() => input.focus(), 0);
      startPolling();
    } else {
      stopPolling();
    }
  };

  launcher.addEventListener('click', () => setOpen(panel.hidden));
  closeButton.addEventListener('click', () => setOpen(false));
  document.querySelectorAll('[data-onlyshop-prompt]').forEach((button) => {
    button.addEventListener('click', () => {
      input.value = button.dataset.onlyshopPrompt;
      form.requestSubmit();
    });
  });
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      form.requestSubmit();
    }
  });

  let pendingBubble = null;
  let pollTimer = null;

  // El sondeo también recoge la respuesta manual de un agente humano desde
  // Odoo, no solo la del bot: por eso sigue corriendo mientras el panel esté
  // abierto y no se detiene apenas llega la primera respuesta.
  const poll = async () => {
    if (!session.token) return;
    let response;
    try {
      response = await fetch(POLL_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionToken: session.token, afterId: session.lastId }),
      });
    } catch (error) {
      console.error('OnlyShop webchat (poll):', error);
      return;
    }
    if (response.status === 404) {
      // Sesión desconocida o expirada en Odoo: se descarta el token para
      // que el siguiente mensaje abra una conversación nueva.
      clearSession();
      saveSession();
      return;
    }
    if (!response.ok) return;
    const data = await response.json().catch(() => null);
    const incoming = Array.isArray(data?.messages) ? data.messages : [];
    if (!incoming.length) return;
    if (pendingBubble) {
      pendingBubble.remove();
      pendingBubble = null;
    }
    incoming.forEach((item) => {
      addMessage(String(item.text || ''), 'bot');
      if (Number.isFinite(item.id) && item.id > session.lastId) session.lastId = item.id;
    });
    saveSession();
  };

  const startPolling = () => {
    if (pollTimer) return;
    poll();
    pollTimer = setInterval(poll, POLL_INTERVAL_MS);
  };

  const stopPolling = () => {
    if (!pollTimer) return;
    clearInterval(pollTimer);
    pollTimer = null;
  };

  // Si quedó una respuesta pendiente de un recargo de página anterior, se
  // recoge apenas carga el script, aunque el panel siga cerrado.
  if (session.token) poll();

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const text = input.value.trim();
    if (!text || sendButton.disabled) return;

    addMessage(text, 'user');
    input.value = '';
    sendButton.disabled = true;
    pendingBubble = addMessage('Escribiendo…', 'bot', true);

    try {
      const response = await fetch(SEND_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text, sessionToken: session.token || undefined }),
      });
      const data = await response.json().catch(() => null);

      if (response.ok) {
        if (data?.sessionToken) {
          session.token = data.sessionToken;
          saveSession();
        }
        startPolling();
        return;
      }

      // Token vencido o desconocido: se descarta y el próximo envío abre
      // conversación nueva. El resto de los 400 (mensaje vacío/largo) y el
      // 429 por límite de frecuencia ya traen texto listo para el cliente.
      if (response.status === 400 && /sesión/i.test(String(data?.message || ''))) {
        clearSession();
        saveSession();
      }
      if (pendingBubble) {
        pendingBubble.remove();
        pendingBubble = null;
      }
      addMessage(
        String(data?.message || 'No pude generar una respuesta. Intenta nuevamente.'),
        'bot',
      );
    } catch (error) {
      console.error('OnlyShop webchat:', error);
      if (pendingBubble) {
        pendingBubble.remove();
        pendingBubble = null;
      }
      addMessage('No pude conectarme en este momento. Intenta nuevamente en unos segundos.', 'bot');
    } finally {
      sendButton.disabled = false;
      input.focus();
    }
  });
})();
